export * from './richtext'
export * from './useDitherBackground'
export * from './brand-dither'
export * from './footnotes'
export * from './asset-helpers'

type IntroSemanticHeadingFields = {
  hasLogoHeading: boolean
  hasIntroContextHeading: boolean
}

export function hasIntroSemanticHeading({hasLogoHeading, hasIntroContextHeading}: IntroSemanticHeadingFields): boolean {
  return hasLogoHeading || hasIntroContextHeading
}
